import React from "react";
import HandMusic from "./components/HandMusic";

function App() {
  return (
    <div className="App">
        <h1>Hand Music</h1>
        <HandMusic />
    </div>
  );
}

export default App;